import { UNSTABLE_ToastQueue as ToastQueue } from "react-aria-components";

export type ToastTone = "info" | "success" | "danger";

export type ToastContent = {
  title: string;
  description?: string;
  tone?: ToastTone;
  /** Shown as a button inside the toast, e.g. Undo. Toasts with an action stay longer. */
  action?: { label: string; onAction: () => void };
  /** Makes the title a link (in-app path), e.g. to the item that was just created. */
  href?: string;
};

export const toastQueue = new ToastQueue<ToastContent>({ maxVisibleToasts: 4 });

type ShowOptions = { timeout?: number };

/**
 * Toasts are for transient events and for offering undo. Persistent problems belong inline.
 * RAC pauses timers on hover and focus, and a toast with an action defaults to 8s.
 */
export const toast = {
  show(content: ToastContent, opts: ShowOptions = {}) {
    return toastQueue.add(content, { timeout: opts.timeout ?? (content.action ? 8000 : 5000) });
  },
  /** Standard undo toast: `toast.undo(m.x(), () => revert())`. */
  undo(title: string, onUndo: () => void, undoLabel: string) {
    return toast.show({ title, action: { label: undoLabel, onAction: onUndo } });
  },
  close(key: string) {
    toastQueue.close(key);
  },
};
